// src/ConsumerApp/api/profile/profile.hooks.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { profileService } from './profile.service';

export const PROFILE_QUERY_KEYS = {
  details: (customerId) => ['profile', String(customerId)],
};

export const useGetProfileDetails = (customerId, token, options = {}) => {
  return useQuery({
    queryKey: PROFILE_QUERY_KEYS.details(customerId),
    queryFn: async () => {
      const res = await profileService.getProfileDetails(customerId, token);
      return res?.data || res || null;
    },
    enabled: Boolean(customerId),
    staleTime: 1000 * 60 * 5, // 5 minutes cache
    ...options,
  });
};

export const useUpdateProfileDetails = (token) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => profileService.updateProfileDetails(payload, token),
    onSuccess: (data, variables) => {
      // 1. Invalidate TanStack query cache so sidebar and profile re-render immediately
      queryClient.invalidateQueries({
        queryKey: PROFILE_QUERY_KEYS.details(variables.id),
      });

      // 2. Sync updated name and type to storage
      try {
        const stored = sessionStorage.getItem('userData') || localStorage.getItem('userData');
        if (stored) {
          const parsed = JSON.parse(stored);
          const updated = {
            ...parsed,
            name: variables.name,
            customer_name: variables.name,
            phone: variables.mobile,
            mobile_number: variables.mobile,
            customer_type: variables.selectedBuyerType,
            company_name: variables.companyName,
          };
          sessionStorage.setItem('userData', JSON.stringify(updated));
          localStorage.setItem('userData', JSON.stringify(updated));
        }
      } catch (e) {
        console.warn('Session sync skipped:', e);
      }
    },
  });
};

export const useDeleteCustomerAccount = (token) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) => profileService.deleteCustomerAccount(payload, token),
    onSuccess: () => {
      queryClient.clear();
    },
  });
};

export const useCustomerLogout = (token) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => profileService.customerLogout(token),
    onSuccess: () => {
      queryClient.clear();
    },
  });
};